import type { PropsWithChildren } from 'react';
import { useCallback, useMemo } from 'react';
import { MediaViewerConfigProvider } from '@frameio/shared/contexts';
import { useOpenInBrowserMutation } from '@frameio/shared/integrations/gql';
import { useSetSequencePosition } from '../hooks';
import { ActiveSequenceSync } from './ActiveSequenceSync';
import { PremierePlayheadSync } from './PremierePlayheadSync';
import { PremierePlayheadSyncButton } from './PremierePlayheadSyncButton';

export function PremiereMediaViewerConfigProvider({
  children,
}: PropsWithChildren) {
  const { setSequencePosition } = useSetSequencePosition();
  const [openInBrowser] = useOpenInBrowserMutation({
    context: { resolveWithUXP: true },
  });

  const onDownloadUrl = useCallback(
    (url: string) => {
      openInBrowser({
        variables: { input: { url, omitLocaleParam: true } },
      });
    },
    [openInBrowser]
  );

  const value = useMemo(
    () => ({
      showFullScreenButton: false,
      showResolutionPicker: false,
      showTranscripts: true,
      showTranscriptionPanel: false,
      showContentCredentials: true,
      onDownloadUrl,
      onTimestampSelected: setSequencePosition,
      PlayheadSyncButton: PremierePlayheadSyncButton,
      PlayheadSync: PremierePlayheadSync,
    }),
    [onDownloadUrl, setSequencePosition]
  );

  return (
    <MediaViewerConfigProvider value={value}>
      <ActiveSequenceSync />
      {children}
    </MediaViewerConfigProvider>
  );
}
